import {UsersProfileDetailsService} from "gw-capability-profileinfo";

const getAccountContact = async (authHeader, authUserData, accountNumber=null) => {
    let accountContactSummaries = await UsersProfileDetailsService.getAccountsContactSummaries(
        authHeader
    );

    const authEmail = authUserData?.email?.toLowerCase();
    const authFirst = authUserData?.firstName?.toLowerCase();
    const authLast = authUserData?.lastName?.toLowerCase();

    if (accountNumber) {
        accountContactSummaries = accountContactSummaries.filter(contactSummary => contactSummary.accountNumber === accountNumber);
    }

    if (!accountContactSummaries || accountContactSummaries.length === 0) {
        return undefined;
    }

    let accountContactSummary;

    for (let index = 0; index < accountContactSummaries.length; index++) {
        const emailMatches = accountContactSummaries[index].namedInsureds.filter(contact => contact?.emailAddress1?.toLowerCase() === authEmail);
        if (emailMatches.length === 1) {
            accountContactSummary = emailMatches[0];
            accountNumber = accountContactSummaries[index].accountNumber;
            break;
        } else if (emailMatches.length > 1) {
            accountContactSummaries = accountContactSummaries.filter(
                summary => summary.namedInsureds.some(
                    insured => insured?.emailAddress1?.toLowerCase() === authEmail
                )
            )
        }
    }
    if (!accountContactSummary) {
        for (let index = 0; index < accountContactSummaries.length; index++) {
            const nameMatches = accountContactSummaries[index].namedInsureds.filter(contact =>
                contact?.firstName?.toLowerCase() === authFirst && contact?.lastName?.toLowerCase() === authLast)
            if (nameMatches.length === 1) {
                accountContactSummary = nameMatches[0];
                accountNumber = accountContactSummaries[index].accountNumber
                break;

            } else if (nameMatches.length > 1) {
                accountContactSummary = accountContactSummaries[index].accountContact;
                accountNumber = accountContactSummaries[index].accountNumber
                break;
            }
        }
    }

    return accountContactSummary === undefined ? undefined :  {
        'accountContact': accountContactSummary,
        'accountNumber': accountNumber
    }
}

const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
}

export  default {
    getAccountContact,
    scrollToTop
}